import * as React from 'react';
import { useLabels } from '@core-front/label-provider';
const CloseButtonCore = (props) => {
    const labels = useLabels();
    const { className, components: { Icon }, label, onClick, icon = '#close-round', } = props;
    const BEM = () => {
        const classArray = ['close-button'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("button", { className: BEM(), onClick: onClick, type: "button" },
        React.createElement("span", { className: "close-button__inner" },
            React.createElement(Icon, { modifiers: icon, className: "close-button__icon" }),
            React.createElement("span", { className: "sr-only" }, label || labels.get('close')))));
};
export { CloseButtonCore as default, };
